import { AI_ASSISTANT_CONSTANTS } from "../constants/aiAssistantConstants";

const normalizeBaseUrl = (url) => (url || "").replace(/\/+$/, "");
const DEFAULT_ASSISTANT_BASE = AI_ASSISTANT_CONSTANTS.API.DEFAULT_BASE_URL;

export const getAssistantBaseUrl = () => {
  const envBase = import.meta.env.VITE_ASSISTANT_URL;
  const base = envBase || DEFAULT_ASSISTANT_BASE;
  return normalizeBaseUrl(base);
};

export const buildAssistantUrl = (path = "") => {
  const base = getAssistantBaseUrl();
  const cleaned = String(path || "").replace(/^\/+/, "");
  return `${base}/${cleaned}`;
};

export const buildAssistantHeaders = (extra = {}) => {
  const token = localStorage.getItem(
    AI_ASSISTANT_CONSTANTS.STORAGE_KEYS.AUTH_TOKEN,
  );
  const headers = { ...extra };
  if (!headers[AI_ASSISTANT_CONSTANTS.API.HEADERS.CONTENT_TYPE]) {
    headers[AI_ASSISTANT_CONSTANTS.API.HEADERS.CONTENT_TYPE] =
      AI_ASSISTANT_CONSTANTS.API.HEADERS.JSON;
  }
  if (token && !headers[AI_ASSISTANT_CONSTANTS.API.HEADERS.AUTHORIZATION]) {
    headers[AI_ASSISTANT_CONSTANTS.API.HEADERS.AUTHORIZATION] = token;
  }
  return headers;
};
